// ********** ENUMS **********
export var OrdersText;
(function (OrdersText) {
    OrdersText["ALL_TIME"] = "All Time";
    OrdersText["DISPLAYING"] = "Displaying";
    OrdersText["HEADER_TEXT_ORDERS"] = "Orders";
    OrdersText["ORDER_PERIOD"] = "Order Period";
    OrdersText["PAST_SIX_MONTHS"] = "Past Six Months";
    OrdersText["PAST_THREE_MONTHS"] = "Past Three Months";
    OrdersText["PLACED_IN_THE"] = "placed in the";
    OrdersText["PLACED_OVER"] = "placed over";
    OrdersText["PLURAL_ORDERS"] = "orders";
    OrdersText["SINGULAR_ORDER"] = "order";
    OrdersText["THE_PAST_YEAR"] = "The Past Year";
    OrdersText["UPCOMING"] = "Upcoming Orders";
    OrdersText["LOADING_ELLIPSIS"] = "Loading Orders...";
    OrdersText["UNEXPECTED_ERROR"] = "Something unexpected happened while loading the page.";
    OrdersText["ERROR_CODE_OH1"] = "Code: OH1";
    OrdersText["ERROR_CODE_OH2"] = "Code: OH2";
    OrdersText["LOADING_UPCOMING_ORDERS"] = "Loading upcoming orders...";
    OrdersText["LOADING_ALL_ORDERS"] = "Loading all orders...";
    OrdersText["LOADING_ORDERS_PAST"] = "Loading orders from the past";
    OrdersText["MONTHS"] = "months...";
})(OrdersText || (OrdersText = {}));
